import graphql__fa2c766c6527fb494632 from "./__generated__/SetEmailLayoutAsDefaultDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import Section from "../form/Section";
import FormDialog from "../dialog/FormDialog";
import type {SetEmailLayoutAsDefaultDialogMutation} from "./__generated__/SetEmailLayoutAsDefaultDialogMutation.graphql";
import {useRelayEnvironment} from "react-relay/hooks";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useErrorContext} from "../../contexts/ErrorContext";
import {useIntl} from "react-intl";

type Props = {
    emailLayout: {
        id: string
        emailLayoutIdentifier: string
        name: string
    }
    onClose: () => void
}

const SetEmailLayoutAsDefaultDialog: React.FC<Props> = ({emailLayout, onClose}) => {
    const intl = useIntl();
    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = () => {
        commitMutationWithErrorHandling<SetEmailLayoutAsDefaultDialogMutation>(
            relayEnvironment,
            {
                mutation: graphql__fa2c766c6527fb494632,
                variables: {
                    input: {
                        id: emailLayout.emailLayoutIdentifier
                    }
                },
                onCompleted: (response, errors) => {
                    if (errors && errors.length > 0) {
                        console.error(errors);
                    }
                    onClose();
                },
                onError: (error) => {
                    console.error(error);
                    onClose();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToSetEmailLayoutAsDefault'})
            }
        )
    }

    return (
        <FormDialog handleCloseDialog={onClose}
                    handleSubmission={handleSubmission}
                    initialValues={{}}
                    headline={intl.formatMessage({id: 'dialog.SetEmailLayoutAsDefaultDialog.headline'})}
                    submitLabel={intl.formatMessage({id: 'button.confirm'})}>
            <Section>
                <p className="text-sm text-gray-600">
                    {intl.formatMessage({id: 'dialog.SetEmailLayoutAsDefaultDialog.confirmMessage'}, {name: emailLayout.name})}
                </p>
            </Section>
        </FormDialog>
    )
}

export default SetEmailLayoutAsDefaultDialog;
